import { SVGProps } from '@components/Icon/types';

export const BoxSelect = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.3, 2.3)">
      <path
        d="M1.7 0C0.761116 0 0 0.761116 0 1.7V3.7C0 4.0866 0.313401 4.4 0.7 4.4C1.0866 4.4 1.4 4.0866 1.4 3.7V1.7C1.4 1.53431 1.53431 1.4 1.7 1.4H3.7C4.0866 1.4 4.4 1.0866 4.4 0.7C4.4 0.313401 4.0866 0 3.7 0H1.7Z"
        fill={fill}
      />
      <path
        d="M17.7 0C18.6389 0 19.4 0.761116 19.4 1.7V3.7C19.4 4.0866 19.0866 4.4 18.7 4.4C18.3134 4.4 18 4.0866 18 3.7V1.7C18 1.53431 17.8657 1.4 17.7 1.4H15.7C15.3134 1.4 15 1.0866 15 0.7C15 0.313401 15.3134 0 15.7 0H17.7Z"
        fill={fill}
      />
      <path
        d="M0 17.7C0 18.6389 0.761116 19.4 1.7 19.4H3.7C4.0866 19.4 4.4 19.0866 4.4 18.7C4.4 18.3134 4.0866 18 3.7 18H1.7C1.53431 18 1.4 17.8657 1.4 17.7V15.7C1.4 15.3134 1.0866 15 0.7 15C0.313401 15 0 15.3134 0 15.7V17.7Z"
        fill={fill}
      />
      <path
        d="M17.7 19.4C18.6389 19.4 19.4 18.6389 19.4 17.7V15.7C19.4 15.3134 19.0866 15 18.7 15C18.3134 15 18 15.3134 18 15.7V17.7C18 17.8657 17.8657 18 17.7 18H15.7C15.3134 18 15 18.3134 15 18.7C15 19.0866 15.3134 19.4 15.7 19.4H17.7Z"
        fill={fill}
      />
      <path
        d="M5.5 18.7C5.5 18.3134 5.8134 18 6.2 18H8.3C8.6866 18 9 18.3134 9 18.7C9 19.0866 8.6866 19.4 8.3 19.4H6.2C5.8134 19.4 5.5 19.0866 5.5 18.7Z"
        fill={fill}
      />
      <path
        d="M10.4 18.7C10.4 18.3134 10.7134 18 11.1 18H13.2C13.5866 18 13.9 18.3134 13.9 18.7C13.9 19.0866 13.5866 19.4 13.2 19.4H11.1C10.7134 19.4 10.4 19.0866 10.4 18.7Z"
        fill={fill}
      />
      <path
        d="M6.2 0C5.8134 0 5.5 0.313401 5.5 0.7C5.5 1.0866 5.8134 1.4 6.2 1.4H8.3C8.6866 1.4 9 1.0866 9 0.7C9 0.313401 8.6866 0 8.3 0H6.2Z"
        fill={fill}
      />
      <path
        d="M11.1 0C10.7134 0 10.4 0.313401 10.4 0.7C10.4 1.0866 10.7134 1.4 11.1 1.4H13.2C13.5866 1.4 13.9 1.0866 13.9 0.7C13.9 0.313401 13.5866 0 13.2 0H11.1Z"
        fill={fill}
      />
      <path
        d="M18.7 13.9C18.3134 13.9 18 13.5866 18 13.2V11.1C18 10.7134 18.3134 10.4 18.7 10.4C19.0866 10.4 19.4 10.7134 19.4 11.1V13.2C19.4 13.5866 19.0866 13.9 18.7 13.9Z"
        fill={fill}
      />
      <path
        d="M18.7 9.00002C18.3134 9.00002 18 8.68662 18 8.30002V6.20002C18 5.81343 18.3134 5.50002 18.7 5.50002C19.0866 5.50002 19.4 5.81343 19.4 6.20002V8.30002C19.4 8.68662 19.0866 9.00002 18.7 9.00002Z"
        fill={fill}
      />
      <path
        d="M0 13.2C0 13.5866 0.313401 13.9 0.7 13.9C1.0866 13.9 1.4 13.5866 1.4 13.2V11.1C1.4 10.7134 1.0866 10.4 0.7 10.4C0.313401 10.4 0 10.7134 0 11.1V13.2Z"
        fill={fill}
      />
      <path
        d="M0 8.30002C0 8.68662 0.313401 9.00002 0.7 9.00002C1.0866 9.00002 1.4 8.68662 1.4 8.30002V6.20002C1.4 5.81343 1.0866 5.50002 0.7 5.50002C0.313401 5.50002 0 5.81343 0 6.20002V8.30002Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'box-select';
